import { map } from "lodash"
import PropTypes from "prop-types"
import { IconButton } from "@mui/material"
import Grid from "@mui/material/Grid"
import OPTooltip from "components/material/tooltip"
import { ACTION, BUTTONS } from "../shapes"

export default function Toolbar({ id, buttons, action }) {
  return (
    <Grid
      id={id}
      spacing={0}
      container
      direction="row"
      sx={{
      alignItems: "center",
    }}
    >
      {map(buttons, ({ id, title, disabled, Icon, onClick }) =>
        <Grid key={id}>
          <OPTooltip title={title}>
            <span>
              <IconButton disabled={disabled} onClick={() => onClick(action)}>
                <Icon />
              </IconButton>
            </span>
          </OPTooltip>
        </Grid>,
      )}
    </Grid>
  )
}

Toolbar.propTypes = {
  id: PropTypes.string,
  buttons: BUTTONS,
  action: ACTION,
}
